/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DeleteEdrFromOrganizationRequest
 */
export interface DeleteEdrFromOrganizationRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeleteEdrFromOrganizationRequest
     */
    organizationsIds: Array<string>;
}

/**
 * Check if a given object implements the DeleteEdrFromOrganizationRequest interface.
 */
export function instanceOfDeleteEdrFromOrganizationRequest(value: object): value is DeleteEdrFromOrganizationRequest {
    if (!('organizationsIds' in value) || value['organizationsIds'] === undefined) return false;
    return true;
}

export function DeleteEdrFromOrganizationRequestFromJSON(json: any): DeleteEdrFromOrganizationRequest {
    return DeleteEdrFromOrganizationRequestFromJSONTyped(json, false);
}

export function DeleteEdrFromOrganizationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeleteEdrFromOrganizationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationsIds': json['organizationsIds'],
    };
}

export function DeleteEdrFromOrganizationRequestToJSON(value?: DeleteEdrFromOrganizationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationsIds': value['organizationsIds'],
    };
}

